'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constant = require('./constant-bbb4776f.js');

function getRetryStrategy() {
  if (!(constant.RuntimeNamespace in window)) {
    return {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getRetryCountLimit: function getRetryCountLimit() {
        return 3;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      findRequestUrl: function findRequestUrl(url, retryCount) {
        return url;
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      emitLoadSuccessEvent: function emitLoadSuccessEvent(url, ctx) {},
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      emitLoadFailedEvent: function emitLoadFailedEvent(url, ctx) {}
    };
  }

  return window[constant.RuntimeNamespace].strategy;
}

exports.getRetryStrategy = getRetryStrategy;
